class EventDispatcher {
	constructor() {
	  this.listeners = {};
	}
  
	$on(event, callback) {
	  if (!this.listeners[event]) {
		this.listeners[event] = [];
	  }
  
	  this.listeners[event].push(callback);
	}
  
	$emit(event, ...args) {
	  const eventListeners = this.listeners[event];
  
	  if (eventListeners) {
		eventListeners.forEach(callback => {
		  callback(...args);
		});
	  }
	}
}

export default EventDispatcher;